import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import ProductCard from "./ProductCard";
import { MyDomain } from "../App";

function normalizeProduct(p) {
  const hasDiscount = !!(
    p.priceAfterDiscount &&
    p.price &&
    p.priceAfterDiscount < p.price
  );
  const discountPercent =
    p.discount ||
    (hasDiscount
      ? Math.round((1 - p.priceAfterDiscount / p.price) * 100)
      : null);
  return {
    id: p.id,
    name: p.name || "",
    image: p.image
      ? p.image.startsWith("http")
        ? p.image
        : `${MyDomain}${p.image}`
      : "",
    price: hasDiscount ? p.priceAfterDiscount : p.price || 0,
    originalPrice: hasDiscount ? p.price : null,
    hasDiscount,
    discountPercent,
    isNew: p.isNew === "Yes",
    brand: p.brand || "",
    gender: p.gender || "",
    rating: 0,
  };
}

export default function Favorite() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || null;
    } catch {
      return null;
    }
  })();

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    fetch(`${MyDomain}Products2/GetUserFavorites`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: user.id }),
    })
      .then((r) => r.json())
      .then(async (favorites) => {
        if (!Array.isArray(favorites) || favorites.length === 0) {
          setProducts([]);
          setLoading(false);
          return;
        }

        const settled = await Promise.all(
          favorites.map((fav) =>
            fetch(`${MyDomain}Products2/GetProduct/${fav.productId}`)
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        );

        setProducts(settled.filter(Boolean).map(normalizeProduct));
        setLoading(false);
      })
      .catch(() => {
        setProducts([]);
        setLoading(false);
      });
  }, []);

  /* ── Not logged in ── */
  if (!user) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "100px 20px",
          gap: 16,
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "rgba(225,29,72,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiHeart size={32} color="#e11d48" />
        </div>
        <p style={{ color: "#1a1a1a", fontSize: 18, fontWeight: 700, margin: 0 }}>
          Please login first
        </p>
        <p style={{ color: "#999", fontSize: 14, margin: 0 }}>
          Login to see your saved favorites.
        </p>
        <button
          onClick={() => navigate("/login")}
          style={{
            marginTop: 8,
            background: "#e11d48",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 32px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Login
        </button>
      </div>
    );
  }

  /* ── Loading ── */
  if (loading) {
    return (
      <div
        style={{
          padding: "80px 0",
          textAlign: "center",
          color: "#999",
          fontSize: 15,
        }}
      >
        Loading favorites…
      </div>
    );
  }

  /* ── Empty ── */
  if (products.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "100px 20px",
          gap: 16,
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "rgba(225,29,72,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiHeart size={32} color="#e11d48" />
        </div>
        <p style={{ color: "#1a1a1a", fontSize: 18, fontWeight: 700, margin: 0 }}>
          No favorites yet
        </p>
        <p style={{ color: "#999", fontSize: 14, margin: 0 }}>
          Tap the heart on any product to save it here.
        </p>
        <button
          onClick={() => navigate("/")}
          style={{
            marginTop: 8,
            background: "#e11d48",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 32px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Browse Products
        </button>
      </div>
    );
  }

  /* ── Grid ── */
  return (
    <div style={{ padding: "28px 0 48px" }}>
      <div style={{ marginBottom: 22 }}>
        <h1
          style={{
            color: "#1a1a1a",
            fontSize: 24,
            fontWeight: 700,
            margin: "0 0 4px",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <FiHeart size={22} color="#e11d48" fill="#e11d48" />
          My Favorites
        </h1>
        <p style={{ color: "#999", fontSize: 13, margin: 0 }}>
          {products.length} saved{" "}
          {products.length === 1 ? "product" : "products"}
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 4,
        }}
      >
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
